import api from '@/common/api.js'

export default {
  namespaced: true,

  state: {
    mecanicoAtivo: null,
    mecanicos: null,
    findMecanico: null,
    funcaoColaborador: null
  },

  getters: {
    mecanicoAtivo: (state) => {
      return state.mecanicoAtivo
    },
    mecanicos: (state) => state.mecanicos,
    findMecanico: (state) => state.findMecanico
  },

  actions: {
    async enviarAvaliacao({ commit }, { data }) {
      try {
        const response = api.post(`colaborador/enviarAvaliacao`, { ...data })

        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async getOsMecanico({ commit, state }, { idMecanico }){

      console.log(idMecanico)
      try {
        const response = api.get(`colaborador/getOsMecanico/${idMecanico}`)

        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async loadMecanicos ({ commit, state }) {
      try {
        const response = await api.get('colaboradores/get-by-funcao', { params: { ds_funcao: [ state.funcaoColaborador ] } })

        commit('setMecanicos', response.data.items)
        return response
      } catch (error) {
        commit('setMecanicos', [])
        throw new Error(error)
      }
    },
    async findMecanico ({ commit }, { idMecanico }){
      try{
        const response = await api.get(`colaboradores/findMecanico/${idMecanico}`)
        
        commit('setFindMecanicos', response.data.nr_seq_fornecedor_externo)
        return response
      } catch (error) {
        commit('setFindMecanicos', [])
        throw new Error(error)
      }
    }
  },

  mutations: {
    setMecanicos (state, items) {
      state.mecanicos = items
    },
    setMecanicoAtivo (state, item) {
      state.mecanicoAtivo = item
    },
    setFindMecanicos (state, item) {
      state.findMecanico = item
    },

    setFuncaoColaborador(state, funcao) {
      state.funcaoColaborador = funcao
    }
  }
}
